import {
  GET_AD_GROUP_STICKY_COLUMNS,
  GET_AD_GROUP_STICKY_COLUMNS_SUCCESS,
  GET_AD_GROUP_STICKY_COLUMNS_ERROR,
  UPDATE_AD_GROUP_STICKY_COLUMNS,
  UPDATE_AD_GROUP_STICKY_COLUMNS_SUCCESS,
  UPDATE_AD_GROUP_STICKY_COLUMNS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  user_column_preference_ad_group: null,
  loading: false
}

const UserAdgroupColumnPreference = (state = initialState, action) => {
  switch (action.type) {
    case GET_AD_GROUP_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case GET_AD_GROUP_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_ad_group: action.payload,
        loading: false
      }

    case GET_AD_GROUP_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_AD_GROUP_STICKY_COLUMNS:
      return {
        ...state,
        loading: true
      }

    case UPDATE_AD_GROUP_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        user_column_preference_ad_group: action.payload,
        loading: false
      }

    case UPDATE_AD_GROUP_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default UserAdgroupColumnPreference;
